module.exports = __webpack_public_path__ + "img/img_06.99e2f448.gif";